import gql from 'graphql-tag'

export const Q_GET_SCHEDULES = gql`
query ($where:ListWhere, $isRestDay:Boolean) {
  schedules (where:$where, isRestDay:$isRestDay) {
    name
    weekDays,
    id,
    currentTeam
    clockIn,
    clockOut,
    schedules {
     id
      startDate
      endDate
     weekDay
      member {
        firstName
        fullName
      }
    }
  }
}`

export const M_CREATE_SCHEDULE = gql`mutation ($memberId: Int!, $weekDay:Int!, $shiftId:Int!,$currentTeam: String, $startDate: Time, $endDate: Time, $scheduleType: String, $candidateShifts: JSON) {
  createSchedule (memberId:$memberId, weekDay:$weekDay, shiftId:$shiftId, currentTeam:$currentTeam, startDate:$startDate, endDate:$endDate, scheduleType:$scheduleType, candidateShifts:$candidateShifts)
  {
       id
       memberId
       startDate
        endDate
       weekDay
    scheduleType
    candidateShifts
    shift {
        id
        name,
        isRestDay,
        clockIn,
        clockOut,
    }
    }
}`

export const M_UPDATE_SCHEDULE = gql`mutation ($id: Int!, $shiftId:Int,$currentTeam: String,$startDate: Time, $endDate: Time, $scheduleType: String, $candidateShifts: JSON) {
  updateSchedule (id:$id, shiftId:$shiftId, currentTeam:$currentTeam,startDate:$startDate, endDate:$endDate, scheduleType:$scheduleType, candidateShifts:$candidateShifts)
  {
       id
       memberId
        startDate
        endDate
       weekDay
    scheduleType
    candidateShifts
    shift {
        id
        name,
        isRestDay,
        clockIn,
        clockOut,
    }
    }
}`

export const M_CREATE_ROTATING_SCHEDULE = gql`mutation ($memberId: Int!, $scheduleType: String!, $rotatingShifts: JSON!, $shiftId: Int!, $startDate: Time!, $currentTeam: String) {
  createSchedule (memberId:$memberId, scheduleType:$scheduleType, rotatingShifts:$rotatingShifts, shiftId:$shiftId, startDate:$startDate, currentTeam:$currentTeam)
  {
       id
       memberId
       rotatingShifts
       startDate
       endDate
       weekDay
     shift {
         id
         name,
         isRestDay,
         clockIn,
         clockOut,
     }
     }
}`

export const M_CREATE_ROTATING_SCHEDULES = gql`mutation ($memberIds: [Int!]!, $rotatingShifts: JSON!, $startDate: Time!) {
  createRotatingSchedules (memberIds:$memberIds, rotatingShifts:$rotatingShifts, startDate:$startDate)
  {
       id
       memberId
       rotatingShifts
       startDate
       endDate
       weekDay
     shift {
         id
         name,
         isRestDay,
         clockIn,
         clockOut,
     }
     }
}`

export const M_DELETE_SCHEDULE = gql`mutation($where:ListWhere) {
deleteSchedule(where:$where)
}`
